import classNames from 'classnames';
import { ABUtils } from '../../utils';

export default function buttonClassNames(version, block, loading) {
    const { isCssVariation, isCssVariationMobile } = ABUtils.getABs();
    return classNames({
        'odf-btn': !isCssVariation,
        'odf-btn-lg odf-btn-flex': !isCssVariation && !block,
        'odf-btn-xl-flex odf-btn-block': !isCssVariation && block,
        'prisma-btn-loading loading': loading,
        [`odf-btn-${version}`]: !isCssVariation && !loading,
        'prisma-btn prisma-btn-default prisma-btn-round': isCssVariation && version === 'secondary',
        'prisma-btn prisma-btn-highlight prisma-btn-round': isCssVariation && version === 'primary',
        'prisma-btn-block': isCssVariationMobile && block,
        'prisma-btn prisma-btn-text': isCssVariation && version === 'text',
    });
}
